module.exports = __webpack_public_path__ + "img/icon-select-unchecked.a5c8d417.svg";